<template>
    <div class="section">
    <!--========== SWIPER SLIDER ==========-->
      <div class="s-swiper" :class="'slider_' + block.blockID">
        <!-- Swiper Wrapper -->
        <div class="swiper-wrapper">
          <div class="s-promo-block-v4 g-bg-position--center swiper-slide" v-for="(slide, i) in block.options.slides" :key="slide.id" :class="{'g-fullheight--xs': block.options.fullHeight}" :style="sectionStyle(slide)">
            <div class="container" :class="{'g-ver-center--xs': block.options.fullHeight, 'g-text-left--xs': slide.align == 'left', 'g-text-right--xs': slide.align == 'right'}">
              <div class="row">
                <div class="col-md-8" :class="{'col-md-offset-4': slide.align == 'right', 'col-md-offset-2 text-center': slide.align == 'center'}">
                  <div class="g-margin-b-50--xs">
                    <h1 class="g-font-size-32--xs g-font-size-45--sm g-font-size-60--md" v-html="slide.title.text" :style="titleStyle(slide)"></h1>
                    <p class="g-font-size-18--xs g-font-size-22--sm" v-html="slide.subtitle.text" :style="subtitleStyle(slide)"></p>
                    <!-- @blur="updateBlockText($event, 'title', 'text')"   / g-color--white-opacity g-color--white -->
                  </div>
                  <!-- Slide Buttons: use type for styling -->
                  <a class="text-uppercase s-btn s-btn--md s-btn--white-brd g-radius--50 g-padding-x-50--xs" v-for="(button, i) in slide.buttons" :key="button.id" :href="button.href" :target="button.target" v-html="button.text" @click.stop.prevent="clickDisable()"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Swiper Wrapper -->

        <!-- Pagination -->
        <div v-if="block.options.pagination === 'bdots'" class="s-swiper__pagination-v1 s-swiper__pagination-v1--bc s-swiper__pagination-v1--white" :class="`swiper-pagination_${this.block.blockID}`"></div>
        <!-- Arrows -->
        <a v-if="block.options.pagination === 'arrows'" href="javascript:void(0);" class="s-swiper__arrow-v1--right s-icon s-icon--md s-icon--white-brd g-radius--circle ti-angle-right js__swiper-btn--next"></a>
        <a v-if="block.options.pagination === 'arrows'" href="javascript:void(0);" class="s-swiper__arrow-v1--left s-icon s-icon--md s-icon--white-brd g-radius--circle ti-angle-left js__swiper-btn--prev"></a>
        <!-- End Arrows -->
      </div>

      <!-- Scroll to next -->
      <a v-if="block.options.scrollNext && block.options.scrollNext.enabled" href="javascript:void(0);" class="js-scroll-to-next s-scroll-to-section-v1--bc g-margin-b-15--xs">
          <span class="g-font-size-18--xs g-color--white ti-angle-double-down"></span>
          <p class="text-uppercase g-color--white g-letter-spacing--3 g-margin-b-0--xs" v-html="block.options.scrollNext.text"></p>
      </a>

      <block-settings :block="block" :order="order" @moveBlockUp="moveBlockUp" @moveBlockDown="moveBlockDown" @deleteBlock="deleteBlock" @afterUpload="afterUpload" @afterSettingsClose="afterSettingsClose"></block-settings>

    </div>
</template>

<script>
import { BlocksMixin } from "../util/mixins";

export default {
  mixins: [BlocksMixin],
  mounted() {
    // this.editables = [this.$refs.title, this.$refs.subtitle];
  },
  methods: {
    sectionStyle(slide) {
      return {
        backgroundImage: slide.bg.url ? `url( ${slide.bg.url} )` : "",
        backgroundColor: slide.bg.color ? slide.bg.color : "",
        padding: this.block.options.fullHeight ? "0" : "200px 0"
      };
    },
    titleStyle(slide) {
      return {
        color: slide.title.color
      };
    },
    subtitleStyle(slide) {
      return {
        color: slide.subtitle.color
      };
    },
    afterUpload() {
      this.$parent.win.refreshSlider(this.block.blockID);
    },
    afterSettingsClose() {
      this.$parent.win.refreshSlider(this.block.blockID);
    },
    appendCustomScript() {
      this.addScriptInline(`
        if(!swiper) { var swiper = []; }
        swiper[${this.block.blockID}] = null;

        $(document).ready(function() {
          initSlider(${this.block.blockID});

          $('.js-scroll-to-next').on('click', function() {
            var page = $("html, body");
            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
            });
            var target = $(this).parent();
            if (target.length) {
              page.animate({
                scrollTop: target.offset().top + target.height()
              }, 600, function(){
                  page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
              });
            }
            return false;
          });

        });
      `);
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/blocks/BlockHeader1.vue